import "../styles/globals.css";
import type { AppProps } from "next/app";
import Head from "next/head";
import Script from "next/script";
import { Web3Provider } from "../providers/Web3Provider";
import PlaysoutAuthBootstrap from "../components/PlaysoutAuthBootstrap";

function MyApp({ Component, pageProps }: AppProps) {
  const appUrl = process.env.NEXT_PUBLIC_URL || "";
  // Default disabled; set NEXT_PUBLIC_ENABLE_ERUDA=true to enable explicitly.
  const enableEruda = process.env.NEXT_PUBLIC_ENABLE_ERUDA === "true";
  const PROJECT_NAME = process.env.NEXT_PUBLIC_APP_NAME || 'Playsout Mini Games';
  const HERO_IMAGE = `${appUrl}/images/share.png`;

  return (
    <>
      <Head>
        <link
          rel="preload"
          href="/fonts/AdelleSans-Regular.woff"
          as="font"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/AdelleSans-Regular.woff2"
          as="font"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/AdelleSans-Semibold.woff"
          as="font"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/AdelleSans-Semibold.woff2"
          as="font"
          crossOrigin=""
        />

        <link rel="icon" href="/favicons/favicon.png" type="image/png" />
        <link rel="icon" href="/favicons/icon.svg" type="image/svg+xml" />
        <link rel="manifest" href="/favicons/manifest.json" />

        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no" />
        <title>{PROJECT_NAME}</title>
        <meta name="description" content={process.env.NEXT_PUBLIC_APP_DESCRIPTION || 'Playsout Mini Games'} />
        <meta name="base:app_id" content="69390401e6be54f5ed71d4e3" />

        {/* Open Graph Metadata */}
        <meta property="og:title" content={process.env.NEXT_PUBLIC_APP_OG_TITLE || PROJECT_NAME} />
        <meta property="og:description" content={process.env.NEXT_PUBLIC_APP_OG_DESCRIPTION || 'Play mini games on Base'} />
        <meta property="og:image" content={process.env.NEXT_PUBLIC_APP_OG_IMAGE || HERO_IMAGE} />
        <meta property="og:url" content={appUrl} />
        <meta property="og:type" content="website" />
        
        {/* Twitter Card Metadata */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={process.env.NEXT_PUBLIC_APP_OG_TITLE || PROJECT_NAME} />
        <meta name="twitter:description" content={process.env.NEXT_PUBLIC_APP_OG_DESCRIPTION || 'Play mini games on Base'} />
        <meta name="twitter:image" content={process.env.NEXT_PUBLIC_APP_OG_IMAGE || HERO_IMAGE} />
      </Head>
      {enableEruda && (
        <Script
          src="https://cdn.jsdelivr.net/npm/eruda"
          strategy="afterInteractive"
          onLoad={() => {
            const eruda = (window as any).eruda;
            if (!eruda || (window as any).__ERUDA_INITIALIZED__) return;
            eruda.init();
            (window as any).__ERUDA_INITIALIZED__ = true;
          }}
        />
      )}
      <Web3Provider>
        <PlaysoutAuthBootstrap />
        <Component {...pageProps} />
      </Web3Provider>
    </>
  );
}

export default MyApp;
